import React from "react";

export default function HowItWorksFooter({ children }) {
  return <div className='how-it-works__footer'>{children}</div>;
}
